// src/utilities/attribute-converters.ts
var jsonAttributeConverter = {
  fromAttribute(value) {
    return JSON.parse(value);
  },
  toAttribute(value) {
    return JSON.stringify(value);
  }
};
var dateAttributeConverter = {
  fromAttribute(value) {
    if (!value)
      return void 0;
    return new Date(Date.parse(value));
  },
  toAttribute(value) {
    return value ? new Date(value).toLocaleDateString() : null;
  }
};
var dateRangeAttributeConverter = {
  fromAttribute(value) {
    if (!value)
      return void 0;
    const parts = value.split(",");
    const start = new Date(Date.parse(parts[0])) || void 0;
    const end = new Date(Date.parse(parts[1])) || void 0;
    return [start, end];
  },
  toAttribute(value) {
    if (!value)
      return null;
    if (!Array.isArray(value))
      return null;
    const startDate = value[0];
    const endDate = value[1];
    if (!startDate)
      return null;
    if (startDate && !endDate)
      return startDate.toLocaleDateString();
    return `${startDate.toLocaleDateString()},${endDate == null ? void 0 : endDate.toLocaleDateString()}`;
  }
};
function createBreakpointConverter(allowedValues) {
  return {
    fromAttribute(value) {
      if (!value)
        return null;
      const found = allowedValues.find((x) => `${x}` === value);
      if (found)
        return found;
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    },
    toAttribute(value) {
      if (!value)
        return null;
      if (allowedValues.some((x) => `${x}` === value))
        return `${value}`;
      return JSON.stringify(value);
    }
  };
}
var booleanAttributeConverter = {
  fromAttribute: (value) => {
    return !value || value === "false" ? false : true;
  },
  toAttribute: (value) => {
    return value ? "true" : "false";
  }
};

export {
  jsonAttributeConverter,
  dateAttributeConverter,
  dateRangeAttributeConverter,
  createBreakpointConverter,
  booleanAttributeConverter
};
